export interface ChatMessageLike {
    role: string;
    toolCalls?: { id: string }[];
    toolCallId?: string;
}

/**
 * True when the assistant has issued a tool call that has no matching tool result yet — i.e. a
 * human-in-the-loop tool (Schema Selection, Confirm/Cancel, adapter picker, …) is on screen
 * awaiting the user's choice. While that is the case the agent run is paused on the tool, so a
 * chat message does nothing and the Send button must be disabled.
 */
export const isAwaitingToolResponse = (messages: ChatMessageLike[]): boolean => {
    // 1. Collect the IDs of every tool call that already has a result.
    //    A "tool" message is a tool *result*; its toolCallId points back to the
    //    assistant tool call it answers.
    const answered = new Set<string>();
    for (const message of messages) {
        if (message.role === "tool" && message.toolCallId) answered.add(message.toolCallId);
    }

    // 2. Return true if any assistant-issued tool call has no matching result yet.
    //    An unanswered call means the agent run is paused on a human-in-the-loop
    //    tool, so the Send button must stay disabled.
    return messages.some(
        message => message.role === "assistant" && (message.toolCalls ?? []).some(call => !answered.has(call.id))
    );
};
